import { render, staticRenderFns } from "./AuthedDocument.vue?vue&type=template&id=25f51487&scoped=true"
import script from "./AuthedDocument.vue?vue&type=script&lang=js"
export * from "./AuthedDocument.vue?vue&type=script&lang=js"
import style0 from "./AuthedDocument.vue?vue&type=style&index=0&id=25f51487&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f51487",
  null
  
)

export default component.exports